import React from 'react';
import FormattedDate, {
	FormattedDateTime,
} from '../../../../../../Components/FormattedDate';
import useTranslation from '../../../../../../Hooks/useTranslation';
import { NCZIPatientJRUZ } from '../../../../Interfaces/ncziPatientInformations';

//@ts-ignore
import styles from './ElectronicHealthCardContactInfoJRUZ.module.scss';
import NZCIListItem from '../../../Base/NZCIListItem';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';

interface Props {
	data: NCZIPatientJRUZ;
}

const ElectronicHealthCardContactInfoJRUZ: React.FC<Props> = props => {
	const { data } = props;
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<ScrollContainer>
				{data.person?.birth?.birthDate && (
					<NZCIListItem
						title='base.shared.dateOfBirth'
						value={
							<>
								<FormattedDate date={data.person.birth.birthDate} />
								{data.person.birth.birthPlace?.city?.displayName &&
									` (${data.person.birth.birthPlace.city.displayName})`}
							</>
						}
						align
					/>
				)}
				{data.person?.sex?.displayName && (
					<NZCIListItem
						title='base.shared.gender'
						value={data.person.sex.displayName}
						align
					/>
				)}
				{data.person?.maritalStatus?.displayName && (
					<NZCIListItem
						title='component.nczi.ezk.maritalStatus'
						value={data.person.maritalStatus.displayName}
						align
					/>
				)}
				{data.person?.nationality?.displayName && (
					<NZCIListItem
						title='base.nationality'
						value={data.person.nationality.displayName}
						align
					/>
				)}
				{data.address && (
					<NZCIListItem
						title='base.addressOfLiving'
						value={
							<>
								{data.address.street} {data.address.descriptiveNumber}/
								{data.address.guideNumber}
							</>
						}
						align
					/>
				)}
				{data.address?.city?.displayName && (
					<NZCIListItem
						title='base.shared.city'
						value={data.address.city.displayName}
						align
					/>
				)}
				{data.address?.district?.displayName && (
					<NZCIListItem
						title='component.nczi.ezk.district'
						value={data.address.district.displayName}
						align
					/>
				)}
				{data.address?.region?.displayName && (
					<NZCIListItem
						title='component.nczi.ezk.region'
						value={data.address.region.displayName}
						align
					/>
				)}
				{data.address?.postCode?.displayName && (
					<NZCIListItem
						title='base.shared.postCode'
						value={data.address.postCode.displayName}
						align
					/>
				)}
				{data.insurance?.company?.displayName && (
					<NZCIListItem
						title='base.shared.insuranceCompany'
						value={
							<>
								{data.insurance.company.displayName} (
								{data.insurance.company.code?.value}) - od{' '}
								{data.insurance.validity?.from}
							</>
						}
						align
					/>
				)}
				{data.insurance?.type?.displayName && (
					<NZCIListItem
						title='base.shared.insurance'
						value={
							<>
								{data.insurance.type.displayName} (
								{data.insurance.isPaid
									? t('component.nczi.ezk.paid')
									: t('component.nczi.ezk.notPaid')}
								)
							</>
						}
						align
					/>
				)}
				{data.identifications?.map((identification: any, index: any) => (
					<NZCIListItem
						key={index}
						title={identification.type.displayName}
						value={identification.value}
						align
					/>
				))}
				{data.identificationDocument?.number && (
					<NZCIListItem
						title='component.nczi.ezk.nationalId'
						value={data.identificationDocument.number}
						align
					/>
				)}
				{data.identificationDocument?.publisher?.displayName && (
					<NZCIListItem
						title='component.nczi.ezk.publisher'
						value={data.identificationDocument.publisher.displayName}
						align
					/>
				)}
				{data.identificationDocument?.validity?.from &&
					data.identificationDocument.validity?.to && (
						<NZCIListItem
							title='base.validity'
							value={
								<>
									<FormattedDate
										date={data.identificationDocument.validity.from}
									/>{' '}
									-{' '}
									<FormattedDate
										date={data.identificationDocument.validity.to}
									/>
								</>
							}
							align
						/>
					)}
			</ScrollContainer>
		</div>
	);
};

export default ElectronicHealthCardContactInfoJRUZ;
